<template>
    <component :is="componentName" v-if="ribbon" v-bind="{ ...ribbon }" />
</template>

<script>
import SRibbonCountdown from './ribbon-countdown.vue';
import SRibbon from './ribbon.vue';
import { hasRibbonCountdown } from './utils.js';

export default {
    name: 'SRibbonContainer',
    components: {
        SRibbon,
        SRibbonCountdown,
    },
    props: {
        ribbons: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            ribbon: null,
        };
    },
    computed: {
        componentName() {
            return hasRibbonCountdown(this.ribbon) ? 's-ribbon-countdown' : 's-ribbon';
        },
    },
    mounted() {
        if (!this.ribbons.length) return;
        this.ribbon = this.ribbons[Math.floor(Math.random() * this.ribbons.length)];
    },
};
</script>
